



























import { Vue, Component } from 'vue-property-decorator';
import yc from './ziben';
@Component
export default class Ziben extends Vue {
  yc: any = yc;
  created() {
    // console.log(JSON.stringify(this.yc));
  }
}
